module.exports = __webpack_public_path__ + "img/ForgeApi.e44170f1.svg";